export default "/static/explore/86f255d8923c60e93c55378a783a789bb15b2d64/_next/static/images/logo-square-win8-275a043cc1f684123da98a0554ffd1b7.png";